import { Dispatch } from "redux";
import { UserFeedBackState } from "../reducer/UserFeedbackReducer";
import { HIDE_FEEDBACK_MODAL, SHOW_FEEDBACK_MODAL } from "../types";


export const showFeedbackModal = (payload: Omit<UserFeedBackState, ''>) => (dispatch: Dispatch) => {
  dispatch({
    type: SHOW_FEEDBACK_MODAL,
    payload: { ...payload, showModal: true },
  });

  // Only auto-dismiss if duration is set and greater than 0
  const duration = payload.duration ?? 3000;
  if (duration > 0) {
    setTimeout(() => {
      dispatch(hideFeedbackModal());
    }, duration);
  }
};

export const hideFeedbackModal = () => ({
  type: HIDE_FEEDBACK_MODAL,
});
